import { Navigate } from "react-router-dom";

export const PublicRoutes = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem("token");
  return !isAuthenticated ? children : <Navigate to="/" />;
};
